// Theme colors for the portfolio
export const THEME_COLORS = {
  // Primary colors for cards
  profile: "#00ff66",
  works: "#6fffa9",
  models: "#ceffe1",

  // Accent color (yellow)
  accent: "#f1ff59",

  // Basic colors
  white: "#ffffff",
  black: "#000000",

  // Background colors
  footerBg: "#464646",
  bodyBg: "#ededed",
  cardBg: "rgba(0, 0, 0, 0.55)",

  // Text colors
  textPrimary: "#000000",
  textSecondary: "#ffffff",

  // Shadow and overlay
  shadowDark: "rgba(0, 0, 0, 0.35)",
} as const;
